import { render, staticRenderFns } from "./KisiSorgulaInfo.vue?vue&type=template&id=2c1af533"
import script from "./KisiSorgulaInfo.vue?vue&type=script&lang=ts"
export * from "./KisiSorgulaInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports